import request from '@/utils/request'

/**
 * 管理员列表
 */
export const getAdminList = async (data) =>
  request({ url: '/admin/list', method: 'POST', data })

/**
 * 新增管理员
 */
export const addAdmin = async (data) =>
  request({ url: '/admin/add', method: 'POST', data })

/**
 * 编辑管理员
 */
export const editAdmin = async (data) =>
  request({ url: '/admin/edit', method: 'POST', data })

/**
 * 删除管理员
 */
export const deleteAdmin = async (data) =>
  request({ url: '/admin/delete', method: 'POST', data })
